module.exports = __webpack_public_path__ + "static/img/2- 6.4.5.bc42800.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/5/2- 6.4.5.png
// module id = F67c
// module chunks = 0